import React, { useEffect, useState } from "react";

import { DropDown, FocusedItem, SelectInput, LoaderStyle } from "./styles";

import Loader from "../Loader/Loader";

function SelectOption(props) {
  const enable = props.enable;
  const bgColor = props.bgColor;
  const items = props.items;
  const amount = props.amountValue;
  const parcelField = props.updateParcelField;
  const interestAmountField = props.updateInterestAmountField;
  const installments = props.installmentValues;
  const updateValue = props.updateFunction;
  const setMdd = props.setMdd;
  const recurrent = props.recurrent
  const [value, setValue] = useState({ over: "", clicked: "" });
  const [error, setError] = useState(true);
  const [showSelect, setShowSelect] = useState(false);

  // Retorna apenas o número da parcela a partir da string no select
  const getInstallmentRef = (value) => {
    if (value) {
      return value.match(/-{0,}(\d+).+/)[1];
    } else {
      return "";
    }
  };

  const getInstallmentValue = (installments, parcel) => {
    const installment = installments.filter( item => item.parcel_number === parcel);
    return installment[0].installment_amount;
  };

  // Evento do clique
  const handleClick = (e) => {
    const parcel = getInstallmentRef(e.target.innerText); // nº da parcela
    updateValue(parcelField, parcel);

    const installment_value = getInstallmentValue(installments, Number(parcel));
    if(installment_value !== Number(amount)) {
      // É uma parcela com juros
      updateValue(interestAmountField, String(installment_value));
    }else{
      updateValue(interestAmountField, "");
    }
    // Seta no mdd o número de parcelas
    setMdd([31, parcel]);

    setValue((old) => ({ ...old, clicked: e.target.innerText }));
  };

  // Evento que limpa o input após seta sair de cima da lista
  const handleLeave = () => setValue((old) => ({ ...old, over: "" }));

  // Evento que mostra no input o valor no qual a seta do mouse esteja em cima
  const showOption = (e) => setValue((old) => ({ ...old, over: e.target.innerText }));

  // Caso o amount altere, verifica a response e limpa o campo input
  useEffect(() => {
    if (items && items.constructor === Array) {
      if(recurrent) {
        setValue((old) => ({ ...old, clicked: items[0] }));
      }
      if(value.clicked) {
        setValue((old) => ({ ...old, clicked: "" }));
      }
      setError(false);
    } else {
      // Se não chegar um array, o erro é lançado
      setError(true);
    }
  }, [amount]);

  return (
    <div style={{ diplay: "flex", width: "100%" }}>
      <SelectInput
        type="text"
        readOnly
        autocomplete="off"
        name="categoria"
        placeholder={error ? "Erro ao calcular parcelas" : showSelect ? "" : "Selecione"}
        hasError={error}
        disabled={!enable || error}
        title={ enable && !error ? "" : "Selecione um tipo de frete para escolher a parcela"}
        defaultValue={value.over || value.clicked}
        onFocus={() => {
          setShowSelect(true);
        }}
        onBlur={() => {
          setShowSelect(false);
        }}
      />
      {!error && (
        <div style={{ position: "absolute", width: "100%" }}>
          <DropDown
            dropSelect={showSelect}
            scrollBgColor={bgColor || "#1d1d1d"}
            onMouseOut={handleLeave}
          >
            {items.length !== 0 ? (
              <div className="listDropDown">
                {items.map((item, index) => (
                  <FocusedItem
                    key={index}
                    onMouseDown={handleClick}
                    onMouseOver={showOption}
                    overColor={bgColor || "#000000"}
                  >
                    {item}
                  </FocusedItem>
                ))}
              </div>
            ) : (
              <LoaderStyle>
                <Loader />
              </LoaderStyle>
            )}
          </DropDown>
        </div>
      )}
    </div>
  );
}

export default SelectOption;
